<div
  [class.ion-padding-top]="inline"
  [class.ion-padding-bottom]="inline"
  [class.h-full]="!inline"
  class="ion-padding-start ion-padding-end flex flex-column ion-justify-content-center ion-align-items-center"
>
  @if (icon) {
  <ion-icon [src]="icon" class="icon-image" aria-hidden="true" size="large"></ion-icon>
  } @else {
  <ion-icon name="search-outline" aria-hidden="true" size="large"></ion-icon>
  }

  <div class="ion-padding-top font-medium ion-text-center text-xl">
    @if (headerTemplate) {
    <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
    } @else {
    {{ 'core.components.noContent.header' | translate }}
    }
  </div>

  @if (messageTemplate) {
  <div class="ion-padding-top">
    <ng-container *ngTemplateOutlet="messageTemplate"></ng-container>
  </div>
  }
</div>
